module.exports = __webpack_public_path__ + "static/img/glzxxd.1289c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linshi/glzxxd.png
// module id = Yvi+
// module chunks = 44